'use client';

var DEFAULT_OPTIONS = {
    isShowDeleteButton: true,
    isShowPreviewButton: true
};

export { DEFAULT_OPTIONS };
//# sourceMappingURL=constants.js.map
